export class FiltroRelatorioDTO {

    pageSize: number;
    pageIndex: number;
    descricao: string;

    constructor(filtro?){
        filtro = filtro || {};

        this.pageIndex = filtro.pageIndex || 1;
        this.pageSize = filtro.pageSize || 10;
        this.descricao = filtro.descricao || "";
    }
}

export class FiltroAdiantamentoDTO {

    pageSize: number;
    pageIndex: number;
    userId: string;
    dataInicio: string;
    dataFim: string;
    listStatusId: string;
    modalidade: string;
    vendedoresId: string;
    empresasId: string;
    gruposUsuariosId: string;
    ordemAprovacao: string;

    constructor(filtro?){
        filtro = filtro || {};

        this.pageIndex = filtro.pageIndex || 1;
        this.pageSize = filtro.pageSize || 10;
        this.userId = filtro.usereId || "";
        this.dataInicio = filtro.dataInicio || "";
        this.dataFim = filtro.dataFim || "";
        this.listStatusId = filtro.listStatusId || "";
        this.modalidade = filtro.modalidade || "";
        this.vendedoresId = filtro.vendedoresId || "";
        this.empresasId = filtro.empresasId || "";
        this.gruposUsuariosId = filtro.gruposUsuariosId || "";
        this.ordemAprovacao = filtro.ordemAprovacao || "";

    }

}